import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '@/contexts/AuthContext';
import type { User } from '@/services/auth.service';

type Role = User['role'];

interface RequireRoleProps {
  /** Rols que poden entrar a les rutes filles. */
  roles: Role[];
}

const FORBIDDEN_ROUTE_MESSAGE = 'No tens permís per obrir aquesta pàgina';

/** El rol de l'usuari és a la llista? */
function hasRequiredRole(role: Role | undefined, roles: Role[]): boolean {
  return !!role && roles.includes(role);
}

/**
 * Ruta-layout per a pàgines d'un rol concret (p. ex. les `/admin/*` que el menú només ensenya a
 * ADMIN). Va dins de `ProtectedRoute`, que ja espera la verificació del login: aquí `user` ja hi és.
 * Si el rol no hi és, redirigeix a `/` i avisa amb un toast.
 */
export default function RequireRole({ roles }: RequireRoleProps) {
  const { user } = useAuth();
  const allowed = hasRequiredRole(user?.role, roles);

  useEffect(() => {
    if (!allowed) toast.error(FORBIDDEN_ROUTE_MESSAGE);
  }, [allowed]);

  if (!allowed) return <Navigate to="/" replace />;
  return <Outlet />;
}
